import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
//import axios from 'axios';

import { getEquipmentById, updateEquipment } from '../../../actions/equipmentActions';
import { getHeader } from "../../../helper";

class EquipmentEdit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePhoto: true,
            activeVideo: true,
            file: null,
            checkInputErrorMessage: false,
            sendingDataErrorMessage: false
        }
    }

    // Посылает запрос на сервер и выводит данные
    componentDidMount() {
        const { session, match, dispatch } = this.props;
        const id_Equipment = match.params.id;
        const { id } = session.currentUser;

        if(!id_Equipment) this.backEquipmentToPage();
        
        let headers = getHeader();

        dispatch(getEquipmentById({
            url: `${window.siteUrl}/api/v1/camera/${id_Equipment}/`,
            params: {user_id:id},
            headers: headers
        }));
    }

    componentWillReceiveProps(nextProps) {
        // если подгрузился нужное оборудование
        if(this.props.equipments.data !== nextProps.equipments.data){
            //console.log("receive", nextProps.equipments);
            this.viewData(nextProps.equipments.data.results[0])
        }
        // если оборудования нет
        else if(this.props.equipments.errorMessage !== nextProps.equipments.errorMessage){
            this.backEquipmentToPage();
        }
    }

    viewData(equipment) {
        this.refs.title.value = equipment.title;
        this.refs.width.value = equipment.width;
        this.refs.height.value = equipment.height;
        this.refs.image.src = equipment.image;
        this.setCamType(equipment.cam_type);
    }

    // Обновляет данные
    updateEquipment() {
      //  const token = localStorage.getItem("id_token");
        const { match, dispatch } = this.props;
        const id_Equipment = match.params.id;
        const formData = new FormData();

        formData.append(`title`, this.refs.title.value);
        formData.append(`width`, this.refs.width.value);
        formData.append(`height`, this.refs.height.value);
        formData.append(`cam_type`, this.getCamType());

        if(this.state.file !== null) {
            formData.append(`image`, this.state.file);
        }

        dispatch(updateEquipment(
            id_Equipment,
            formData,
            () => this.backEquipmentToPage()
        ));
    }

    // Срабатывает при переключения значка фото
    switchPhoto() {
        this.setState({
            activePhoto: !this.state.activePhoto
        });
    }

    // Срабатывает при переключения значка видео
    switchVideo() {
        this.setState({
            activeVideo: !this.state.activeVideo
        });
    }


    editEquipment() {
        // Если ошибка выводит сообщение
        if (this.state.activePhoto === false && this.state.activeVideo === false) {
            this.setState({
                checkInputErrorMessage: true
            });
        } else {
            this.setState({
                checkInputErrorMessage: false
            });
        }
    }

    handleImageChange(e) {
        e.preventDefault();
        // console.log('handleImageChange');
        const reader = new FileReader();
        const file = e.target.files[0];

        this.setState({ file: file });

        reader.onloadend = () => {
            const res = reader.result;
            this.refs.image.src = res;
        }

        reader.readAsDataURL(file)
    }

    // Задает значение отображаемых значыков
    setCamType(type) {
        if (type === 0) {
            this.setState({
                activePhoto: true,
                activeVideo: false
            });
        } else if (type === 1) {
            this.setState({
                activePhoto: false,
                activeVideo: true
            });
        } else if (type === 2) {
            this.setState({
                activePhoto: true,
                activeVideo: true
            });
        }
    }

    getCamType() {
        if (this.state.activePhoto === true && this.state.activeVideo === false) {
            return 0;
        } else if (this.state.activePhoto === false && this.state.activeVideo === true) {
            return 1;
        } else if (this.state.activePhoto === true && this.state.activeVideo === true) {
            return 2;
        }
    }

    backEquipmentToPage() {
        const {history, session} = this.props;

        history.push(`/profile/${session.currentUser.id}/equipment`);
    }

    handleSubmitCreate(event) {
        event.preventDefault();
        // console.log('handleSubmitCreate');

        if (this.state.checkInputErrorMessage === false) {
            this.updateEquipment();
        }
    }
    render() {

        return (
            <div className="menu-content-equipment-edit menu-content-item tab-parent screen-bottom-block">
                <div className="rounded-white-block">


                    <div className="white-block-top">
                        <h3>Редактировать оборудование</h3>
                    </div>

                    <div className="white-block-content">

                        <div className="edit-form-wrap">

                            <form id="formCreate" action="" onSubmit={(event) => { this.handleSubmitCreate(event) }}>
                                <input type="text" placeholder="Модель телефона" required className="width100" ref="title" />

                                <input type="text" placeholder="Ширина снимка (px)" required pattern="^[0-9]+$" className="width100" ref="width" />

                                <input type="text" placeholder="Высота снимка (px)" required pattern="^[0-9]+$" className="width100" ref="height" />

                                <div className="icon-wrap" >
                                    <div className="actions-text">
                                        <div className="icon-text-photo">Фото</div>
                                        <div className="icon-text-video">Видео</div>
                                    </div>
                                    <div className="actions" >
                                        <div className={this.state.activePhoto ? "action-photo" : "action-photo not-exist"}
                                            onClick={() => { this.switchPhoto() }}>
                                        </div>
                                        <div className={this.state.activeVideo ? "action-video" : "action-video not-exist"}
                                            onClick={() => { this.switchVideo() }}>
                                        </div>
                                    </div>
                                </div>
                                {
                                    this.state.checkInputErrorMessage
                                        ? <span className="input-error-text">Нужно выбрать фото или видео.</span> : ''
                                }

                                <input type="file" name="imageFile" accept="image/jpeg,image/png" onChange={this.handleImageChange.bind(this)} ref="imageFile" />
                                <img ref="image" alt="" />
                            </form>
                            {
                                this.state.sendingDataErrorMessage
                                    ? <span className="input-error-text">Ошибка отправки данных</span> : ''
                            }    
                        </div>


                        <div className="actions-buttont edit-buttons">
                            <div className="big-button empty-button edit-button-item">
                                <button onClick={() => { this.backEquipmentToPage() }}>Отмена</button>
                            </div>
                            <div className="big-button edit-button-item">
                                <button form="formCreate" onClick={() => { this.editEquipment() }}>Сохранить</button>
                            </div>
                        </div>

                    </div>


                </div>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default withRouter(connect(mapStateToProps)(EquipmentEdit));


// WEBPACK FOOTER //
// ./src/components/Profile/SubEquipment/EquipmentEdit.js